/* eslint-disable prettier/prettier */
import {
  TRAINING_SUB_MENU_LIST,
  ASSETS_SUB_MENU_LIST,
  CALL_AI_SUB_MENU_LIST,
  COACHING_SUB_MENU_LIST,
  TEAM_ANALYTICS_SUB_MENU_LIST,
  DSR_SUB_MENU_LIST,
} from './enums';

export const TRAINING_SUB_MENU_REGEX_MAP = {
  [TRAINING_SUB_MENU_LIST.TRAINING_SERIES]: [
    /\/learner\/training\/programs/,
    /\/training\/program/,
  ],
  [TRAINING_SUB_MENU_LIST.TRAINING_MODULES]: [
    /\/training\/modules\//,
    /\/ui\/coaching\/\d+\/learner/,
    /\/ui\/reinforcement\//,
    /\/ui\/checklist\//,
    /\/admin\/update\//,
    /\/admin\/course\//,
    /\/admin\/assessment\//,
    /\/admin\/ilt\//,
  ],
  [TRAINING_SUB_MENU_LIST.TRAINING_FILES]: [/\/training\/files\//],
  [TRAINING_SUB_MENU_LIST.TRAINING_LEADERBOARD]: [/\/training\/leaderboard\//],
  [TRAINING_SUB_MENU_LIST.TRAINING_TASKS]: [/\/training\/tasks\//],
  [TRAINING_SUB_MENU_LIST.TRAINING_AI_TUTORIALS]: [
    /\/training\/tutorials\//,
    /\/learner\/tutorial\//,
  ],
};

export const ASSETS_SUB_MENU_REGEX_MAP = {
  [ASSETS_SUB_MENU_LIST.ASSETS_ASSETS]: [/\/ui\/assets\//],
  [ASSETS_SUB_MENU_LIST.ASSETS_MY_ASSETS]: [/\/ui\/assets\/my-assets\//],
  [ASSETS_SUB_MENU_LIST.ASSETS_INTERACTIONS]: [/\/ui\/assets\/interactions\//],
};

export const CALL_AI_SUB_MENU_REGEX_MAP = {
  [CALL_AI_SUB_MENU_LIST.CALL_AI_RECORDINGS]: [
    /\/callai\/recordings(\/(?!library\/).*)?(\?.*)?$/, // match /callai/recordings + anything except /library/ + optional query params
    /\/callai\/recording\/(?!library\/).*$/, // anything except /library/
  ],
  [CALL_AI_SUB_MENU_LIST.CALL_AI_TEAM_RECORDINGS]: [/\/callai\/recordings\/team$/],
  [CALL_AI_SUB_MENU_LIST.CALL_AI_UPCOMING_MEETINGS]: [/\/callai\/my-upcoming-meetings(\/.*)?/],
  [CALL_AI_SUB_MENU_LIST.CALL_AI_MY_ANALYTICS]: [/\/callai\/my-analytics(\/.*)?/],
  [CALL_AI_SUB_MENU_LIST.CALL_AI_PREFERENCES]: [/\/callai\/preferences(\/.*)?/],
  [CALL_AI_SUB_MENU_LIST.CALL_AI_ESSENTIALS]: [/\/callai\/callai-essentials(\/.*)?/],
  [CALL_AI_SUB_MENU_LIST.CALL_AI_LIBRARIES]: [
    /\/callai\/libraries(\/.*)?$/, // /callai/libraries...
    /\/callai\/recordings\/library\/.*$/, // /callai/recordings/library/...
  ],
};

export const DSR_SUB_MENU_REGEX_MAP = {
  [DSR_SUB_MENU_LIST.DSR_ROOMS]: [/\/learner\/dsr\/rooms/, /\/learner\/dsr\/room/],
  [DSR_SUB_MENU_LIST.DSR_TEMPLATES]: [/\/learner\/dsr\/templates/, /\/learner\/dsr\/room-template/],
  [DSR_SUB_MENU_LIST.DSR_INSIGHTS]: [/\/learner\/dsr\/insights/],
  [DSR_SUB_MENU_LIST.DSR_DEALS]: [/\/learner\/dsr\/more\//],
  [DSR_SUB_MENU_LIST.DSR_SETTINGS]: [/\/learner\/dsr\/settings\//],
};

export const TEAM_ANALYTICS_SUB_MENU_REGEX_MAP = {
  [TEAM_ANALYTICS_SUB_MENU_LIST.TEAM_ANALYTICS_MY]: [/\/analytics\/my-analytics\//],
  [TEAM_ANALYTICS_SUB_MENU_LIST.TEAM_ANALYTICS_HIERARCHY_REPORTS]: [
    /\/analytics\/new-rollup\//,
    /\/analytics\/learners\//,
  ],
  [TEAM_ANALYTICS_SUB_MENU_LIST.TEAM_ANALYTICS_RELATIONSHIP_REPORTS]: [/\/analytics\/managers\//],
  [TEAM_ANALYTICS_SUB_MENU_LIST.TEAM_ANALYTICS_CALLAI]: [/\/analytics\/callai\//],
  [TEAM_ANALYTICS_SUB_MENU_LIST.ANALYTICS_READINESS_INDEX]: [/\/analytics\/readiness-index/],
  [TEAM_ANALYTICS_SUB_MENU_LIST.TEAM_ANALYTICS_COACHING]: [/\/analytics\/coaching\//],
};

export const COACHING_SUB_MENU_REGEX_MAP = {
  [COACHING_SUB_MENU_LIST.COACHING_SESSIONS]: [
    /\/review\/coaching-dashboard/,
    /\/new\/ui\/coaching\/(13|15)\/review/,
  ],
  [COACHING_SUB_MENU_LIST.MISSION_REVIEW]: [
    /\/review\/mission-dashboard/,
    /\/new\/ui\/coaching\/(9|10|11|12)\/review/,
  ],
  [COACHING_SUB_MENU_LIST.MISSION_AND_AI_ROLEPLAY_REVIEW]: [
    /\/review\/mission-dashboard/,
    /\/new\/ui\/coaching\/(9|10|11|12|16)\/review/,
  ],
  [COACHING_SUB_MENU_LIST.AI_ROLEPLAY_REVIEW]: [
    /\/review\/mission-dashboard/,
    /\/new\/ui\/coaching\/16\/review/,
  ],
};

export const SUB_LEARNER_MENU_REGEX_MAP = {
  ...ASSETS_SUB_MENU_REGEX_MAP,
  ...CALL_AI_SUB_MENU_REGEX_MAP,
  ...TRAINING_SUB_MENU_REGEX_MAP,
  ...COACHING_SUB_MENU_REGEX_MAP,
  ...TEAM_ANALYTICS_SUB_MENU_REGEX_MAP,
  ...DSR_SUB_MENU_REGEX_MAP,
};
